import recipientWellLinkedInStore from '../store/linkedInStore';
import { action } from 'satcheljs/lib/legacy';

export default action('updateBindingPromoClicked')(function updateBindingPromoClicked(
    bindingPromoClicked: boolean
) {
    recipientWellLinkedInStore.bindingPromoClicked = bindingPromoClicked;
});
